import React from 'react';
import {
  SecondaryNavigation as SecondaryNavigationFromLib,
  SecondaryNavigationGradient,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { RoutedLink } from 'shared/components';
import { SecondaryNavigationProps } from './SecondaryNavigationConfig';

const SecondaryNavigation = ({
  regionId = 'secondaryNavigation',
  items,
}: React.PropsWithChildren<SecondaryNavigationProps>) => {
  return (
    <LinkRegion regionId={regionId}>
      <SecondaryNavigationGradient>
        <SecondaryNavigationFromLib>
          {items.map(({ title, id, active, link: { url } }) => {
            const [urlWithoutExtension] = url.split('.html');
            return (
              <RoutedLink
                to={urlWithoutExtension}
                key={id}
                active={active}
                onClick={() => {
                  trackCustomLink(title ?? '');
                }}
              >
                {title}
              </RoutedLink>
            );
          })}
        </SecondaryNavigationFromLib>
      </SecondaryNavigationGradient>
    </LinkRegion>
  );
};

export default SecondaryNavigation;
